import React from "react";

const IconList = () => {
  // This svg is a copy from public/icons/collection/list.svg
  // Without the fill values.
  // If you find out it no longer matches the original file, please update it
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 16C5.55228 16 6 16.4477 6 17V19C6 19.5523 5.55228 20 5 20H3C2.44772 20 2 19.5523 2 19V17C2 16.4477 2.44772 16 3 16H5ZM21 17.25C21.4142 17.25 21.75 17.5858 21.75 18C21.75 18.3797 21.4678 18.6935 21.1018 18.7432L21 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18C8.25 17.6203 8.53215 17.3065 8.89823 17.2568L9 17.25H21ZM5 10C5.55228 10 6 10.4477 6 11V13C6 13.5523 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13V11C2 10.4477 2.44772 10 3 10H5ZM21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.3797 21.4678 12.6935 21.1018 12.7432L21 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.6203 8.53215 11.3065 8.89823 11.2568L9 11.25H21ZM5 4C5.55228 4 6 4.44772 6 5V7C6 7.55228 5.55228 8 5 8H3C2.44772 8 2 7.55228 2 7V5C2 4.44772 2.44772 4 3 4H5ZM21 5.25C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.3797 21.4678 6.69349 21.1018 6.74315L21 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6C8.25 5.6203 8.53215 5.30651 8.89823 5.25685L9 5.25H21Z"
      />
    </svg>
  );
};

export default IconList;
